import { render } from "./ems-document.vue?vue&type=template&id=9ca50aec&ts=true"
import script from "./ems-document.vue?vue&type=script&lang=ts"
export * from "./ems-document.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__